module.exports = __webpack_public_path__ + "images/p-value-10.webp";